import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { QuestionResponseConfiguration } from '../QuestionResponses/QuestionResponseConfiguration';
import { AnswerOption, AddEditQuestion } from '../../Models/RequestModels';

@Component({
    selector: 'QuestionInput',
    templateUrl: './QuestionInput.html',
})
export class QuestionInput extends BaseComponent implements OnInit {

    @Input() Model: AddEditQuestion;
    @Output() ModelChange = new EventEmitter();
    
    @Input() isSelected = false;
    @Input() Position: number;
    @Input() AddDisabled = false;

    @Output() didAction = new EventEmitter();

    placeholderText = 'Write your question'

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        public modalService: NgbModal) {

        super(translate, toastr, route, router, masterService);
    }

    ngOnInit() { }

    didTapActionButton(action: string) {
        this.didAction.emit({ action, question: this.Model });
    }

    didTapDropdown(event) {
        event.preventDefault()
    }

    openResponseConfiguration() {
        const modal: NgbModalRef = this.modalService.open(QuestionResponseConfiguration, {
            centered: true,
            size: 'lg',
            backdrop: 'static'
        });

        const configuration: QuestionResponseConfiguration = modal.componentInstance;
        if (this.Model.AnswerOption) {
            setTimeout(() => {
                configuration.setSelectedAnswerOption(this.Model.AnswerOption, this.Model.QuestionDesc, true);
            }, 100);
            
        }
        
        modal.result.then((value: AnswerOption) => {
            this.Model.AnswerOption = value;
            this.ModelChange.emit(this.Model);
        })
    }

}
